import React from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import Skeleton from "@mui/material/Skeleton";
import FolderIcon from "@mui/icons-material/Folder";
import { formatTimestamp } from "../../../../utils/formatter/dateTimeFormatter";
import { formatPath } from "../../../../utils/fileSystemHelper";
import { DivStyled } from "./InvoincingTable.styles";
const InvoicingTable = (props) => {
  const { className, reports, breadCrumbs, rowsPerPage, loading, goToFolder, downloadReport } = props;
  return /* @__PURE__ */ React.createElement(Card, { className }, /* @__PURE__ */ React.createElement("div", { role: "presentation" }, /* @__PURE__ */ React.createElement(Breadcrumbs, { "aria-label": "breadcrumb", sx: { padding: "10px" } }, breadCrumbs.map((breadCrumb, idx, arr) => /* @__PURE__ */ React.createElement(
    Chip,
    {
      key: breadCrumb.path,
      color: idx === arr.length - 1 ? "primary" : "inherit",
      label: breadCrumb.name,
      onClick: () => {
        goToFolder(breadCrumb.path);
      }
    }
  )))), /* @__PURE__ */ React.createElement(CardContent, { sx: { padding: 0 } }, /* @__PURE__ */ React.createElement(PerfectScrollbar, null, /* @__PURE__ */ React.createElement(Box, { sx: { minWidth: 1050 } }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "reports.name" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "reports.createdAt" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "reports.actions" })))), /* @__PURE__ */ React.createElement(TableBody, null, loading && new Array(rowsPerPage).fill((index) => index).map((value, index) => /* @__PURE__ */ React.createElement(TableRow, { key: index }, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)))), !loading && reports.map((report) => /* @__PURE__ */ React.createElement(TableRow, { hover: true, key: report.path }, /* @__PURE__ */ React.createElement(TableCell, null, report.type === "dir" ? /* @__PURE__ */ React.createElement(
    DivStyled,
    {
      role: "presentation",
      onClick: () => {
        goToFolder(report.path);
      }
    },
    /* @__PURE__ */ React.createElement(FolderIcon, null),
    /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, formatPath(report.path))
  ) : /* @__PURE__ */ React.createElement(DivStyled, null, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, formatPath(report.path)))), /* @__PURE__ */ React.createElement(TableCell, null, formatTimestamp(report.last_modified)), /* @__PURE__ */ React.createElement(TableCell, null, report.type !== "dir" && /* @__PURE__ */ React.createElement(Button, { onClick: () => downloadReport(report.path) }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "reports.download" })))))))))), /* @__PURE__ */ React.createElement(CardActions, { sx: { justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(TableFooter, null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, null, `Results: ${reports.length}`)))));
};
InvoicingTable.propTypes = {
  className: PropTypes.string,
  reports: PropTypes.array.isRequired
};
export default InvoicingTable;
